import React, { FC, useState } from 'react'
import { Spacing } from 'Pages/landings/newLandings/common/style'
import { CheckWithElement } from 'Pages/landings/newLandings/common/components'
import { Text } from 'Pages/landings/newLandings/selfEmployed/Tools/styled'
import { ListWithImgComponent } from 'Pages/landings/newLandings/selfEmployed/common/components/ListWithImg'
import notSelfEmployedJpg from './notSelfEmployedJpg.jpg'
import notSelfEmployedWebp from './notSelfEmployedWebp.webp'
import selfEmployedJpg from './selfEmployedJpg.jpg'
import selfEmployedWebp from './selfEmployedWebp.webp'
import { Control, List, AdvantagesElementStyled, ListWrapper, TabStyled } from './styled'

export const TabsWithControlComponent: FC = () => {
	const [tabActive, isTabActive] = useState(0)
	const notSelfEmployed = (
		<ListWrapper tabActive={tabActive !== 0}>
			<List>
				<AdvantagesElementStyled
					title="Зарегистрируйтесь за&nbsp;несколько минут"
					text="После подключения сервиса «Своё дело» в&nbsp;СберБанк Онлайн вы&nbsp;получите статус самозанятого"
				/>
				<AdvantagesElementStyled
					title="Получите налоговый бонус 10&nbsp;000&nbsp;₽"
					text="Налоговая ставка будет ниже, пока бонус не&nbsp;исчерпан.
				3% вместо 4% на&nbsp;доход от&nbsp;физлиц, 4%&nbsp;вместо 6% на&nbsp;доход от&nbsp;юрлиц"
				/>
				<AdvantagesElementStyled
					title="Совмещайте своё дело с&nbsp;основной работой"
					text="Легко начать: не&nbsp;нужно платить налог, если нет&nbsp;дохода"
				/>
			</List>
			<Spacing height="64px" heightLX="80px" />
			<ListWithImgComponent
				imgWebp={notSelfEmployedWebp}
				imgJpg={notSelfEmployedJpg}
				title="Всё для самозанятого в&nbsp;бесплатном сервисе «Своё&nbsp;дело»"
			>
				<CheckWithElement
					text={() => <Text>Создание онлайн-чеков и&nbsp;отправка клиентам</Text>}
				/>
				<CheckWithElement text={() => <Text>Статистика доходов и&nbsp;расходов</Text>} />
				<CheckWithElement
					text={() => (
						<Text>
							Оплата налога — сумма будет рассчитываться автоматически с&nbsp;учётом налогового
							бонуса
						</Text>
					)}
				/>
			</ListWithImgComponent>
		</ListWrapper>
	)
	const selfEmployed = (
		<ListWrapper tabActive={tabActive !== 1}>
			<List>
				<AdvantagesElementStyled
					title="Получите доступ к&nbsp;бесплатным инструментам"
					text="Платформа для видеоконференций, создание сайта
				с&nbsp;помощью искусственного интеллекта и&nbsp;другие сервисы"
				/>
				<AdvantagesElementStyled
					title="Автоматизируйте создание чеков"
					text="Сэкономит ваше время и&nbsp;зарегистрирует доход от&nbsp;физических лиц в&nbsp;налоговой"
				/>
				<AdvantagesElementStyled
					title="Принимайте платежи по&nbsp;QR-коду без комиссии"
					text="Его можно распечатать или показать на&nbsp;экране телефона для получения оплаты"
				/>
			</List>
			<Spacing height="64px" heightLX="80px" />
			<ListWithImgComponent
				imgWebp={selfEmployedWebp}
				imgJpg={selfEmployedJpg}
				title="Возможности сервиса"
			>
				<CheckWithElement
					text={() => (
						<Text>
							<b>Управляйте своим делом в&nbsp;СберБанк Онлайн</b> <br /> Отслеживайте статистику
							доходов и&nbsp;расходов, оплачивайте налог и&nbsp;создавайте чеки
						</Text>
					)}
				/>
				<CheckWithElement
					text={() => (
						<Text>
							<b>Протестируйте сервис «Своё дело», чтобы решить, подходит ли он&nbsp;вам</b> <br />
							Отключать другие приложения для самозанятых не нужно
						</Text>
					)}
				/>
			</ListWithImgComponent>
		</ListWrapper>
	)
	return (
		<>
			<Control>
				<TabStyled
					tabActive={tabActive === 0}
					onClick={() => isTabActive((prev) => (prev !== 0 ? 0 : prev))}
				>
					Нет, хочу стать самозанятым
				</TabStyled>
				<TabStyled
					tabActive={tabActive === 1}
					onClick={() => isTabActive((prev) => (prev !== 1 ? 1 : prev))}
				>
					Да, уже самозанятый
				</TabStyled>
			</Control>
			<Spacing height="64px" heightLX="80px" />
			{notSelfEmployed}
			{selfEmployed}
		</>
	)
}
